import React from "react"

class Error extends React.Component{
    render(){
        return(
            <div>
                <h3 className="loading">{this.props.error}</h3>
            </div>
        )
    }
}

export default Error